import React, { useContext } from 'react';
import { Box, Typography, Grid, Card, CardActionArea, CardContent } from '@mui/material';
import StoreIcon from '@mui/icons-material/Store';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import GroupIcon from '@mui/icons-material/Group';
import CategoryIcon from '@mui/icons-material/Category';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CelebrationIcon from '@mui/icons-material/Celebration';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';

export default function ConfiguracionPage() {
  const navigate = useNavigate();
  const { permissions, user } = useContext(UserContext);
  const isSuperAdmin = (user?.role || '').toLowerCase() === 'super_admin';
  const hasAnyPermission = (...requiredPermissions) => (
    requiredPermissions.some((permission) => permissions.includes(permission))
  );

  const opciones = [
    {
      label: "Gestionar Estaciones",
      icon: <StoreIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/station'),
      disabled: false,
      visible: hasAnyPermission('stations.read', 'stations.read_all'),
    },
    {
      label: "Gestionar Áreas",
      icon: <WorkOutlineIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/positions'),
      disabled: false,
      visible: hasAnyPermission('stations.read', 'stations.read_all'),
    },
    {
      label: "Gestionar Usuarios",
      icon: <GroupIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/user-config'),
      disabled: false,
      visible: hasAnyPermission('users.read'),
    },
    {
      label: "Gestionar Tipos de Licencia",
      icon: <CategoryIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/type-license'),
      disabled: false,
      visible: hasAnyPermission('licenses.read'),
    },
    {
      label: "Gestionar Turnos",
      icon: <ScheduleIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/workshift-config'),
      disabled: false,
      visible: hasAnyPermission('workshifts.read'),
    },
    {
      label: "Gestionar Dotaciones",
      icon: <PeopleAltIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/dotacion'),
      disabled: false,
      visible: hasAnyPermission('staffing.read', 'staffing.read_all'),
    },
    {
      label: "Configuración General",
      icon: <SettingsIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/general-config'),
      disabled: false,
      visible: hasAnyPermission('workshifts.read'),
    },
    {
      label: "Configurar Feriados",
      icon: <CelebrationIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/public-holidays-config'),
      disabled: false,
      visible: hasAnyPermission('licenses.read'),
    },
    {
      label: "Logs / Auditoría",
      icon: <HistoryIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/auditoria'),
      disabled: false,
      visible: isSuperAdmin,
    },
    {
      label: "Gestión de permisos",
      icon: <AdminPanelSettingsIcon sx={{ fontSize: 50 }} />,
      onClick: () => navigate('/permisos'),
      disabled: false,
      visible: isSuperAdmin,
    },
  ].filter((opcion) => opcion.visible);

  const enabledOptions = opciones.filter((opcion) => !opcion.disabled);

  return (
    <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="h4" gutterBottom align="center">
        Configuración
      </Typography>
      {enabledOptions.length === 0 && (
        <Typography color="text.secondary" align="center" sx={{ mt: 2 }}>
          No hay módulos de configuración disponibles para tu rol.
        </Typography>
      )}
      <Box sx={{ width: '100%', maxWidth: 950, marginTop: '50px' }}>
        <Grid container spacing={5} justifyContent="center">
          {opciones.map((opcion, idx) => (
            <Grid item xs={12} sm={6} md={3} key={idx} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Card sx={{
                width: 180,
                height: 180,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 4,
                boxShadow: 3,
                bgcolor: opcion.disabled ? "#f5f5f5" : "white", // grisecito claro
                opacity: opcion.disabled ? 0.7 : 1
              }}>
                <CardActionArea
                  onClick={opcion.disabled ? undefined : opcion.onClick}
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    cursor: opcion.disabled ? 'not-allowed' : 'pointer'
                  }}
                  disabled={opcion.disabled}
                >
                  <CardContent sx={{
                    textAlign: 'center',
                    color: opcion.disabled ? '#bdbdbd' : 'inherit'
                  }}>
                    {React.cloneElement(opcion.icon, {
                      color: opcion.disabled ? undefined : "inherit",
                      sx: { fontSize: 50, color: opcion.disabled ? "#bdbdbd" : "inherit" }
                    })}
                    <Typography variant="h6" sx={{
                      mt: 2,
                      color: opcion.disabled ? '#bdbdbd' : 'inherit'
                    }}>
                      {opcion.label}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
